import {
  Grid,
  Popper,
  PopperProps,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { sanitizeTestId } from '@roc/feature-utils';
import {
  TextField,
} from '@roc/ui';
import { ChangeEvent, useMemo } from 'react';
import { FieldLabel, VirtualizedAutocomplete } from '@roc/ui';

const useStyles = makeStyles(theme => ({
  popper: {
    minWidth: '450px',
    zIndex: 9999,
  },
}));

type TaskReasonFieldProps = {
  label: string;
  value: string;
  onChange: (event: ChangeEvent<{}>, value: string) => void;
  disabled: boolean;
  options: string[];
}

export const TaskReasonField: React.FC<TaskReasonFieldProps> = ({
  label,
  value,
  onChange,
  disabled,
  options,
}) => {
  const classes = useStyles();

  const PopperComponent = useMemo(() => {
    return (props: PopperProps) => <Popper {...props} className={classes.popper} />;
  }, []);

  return (
    <>
      <FieldLabel>{label}</FieldLabel>
      <VirtualizedAutocomplete
        optionHeight={48}
        id={sanitizeTestId(label)}
        value={value ?? ''}
        options={options}
        renderInput={params => (
          <TextField
            testId={sanitizeTestId(label)}
            variant="outlined"
            {...params}
          />
        )}
        getOptionLabel={(option: string) => option ?? ''}
        getOptionSelected={(option: string, selected: string) =>
          option === selected
        }
        onChange={(event: ChangeEvent<{}>, selected: string) => {
          onChange(event, selected ?? '');
        }}
        fullWidth
        disabled={disabled}
        PopperComponent={PopperComponent}
        renderOption={(option: string) => (
          <>
            <Grid container alignItems={'center'} wrap={'nowrap'} spacing={2}>
              <Grid item>
                <Typography>{option}</Typography>
              </Grid>
            </Grid>
          </>
        )}
      />
    </>
  );
};